import { ApiFlightRange } from 'common/types'
import { FlightRange } from 'common/types'

export const FlightRangeModel = (flightRange: ApiFlightRange): FlightRange => {
  const { flightNumberEnd = '', flightNumberStart = '' } = flightRange

  return { flightNumberEnd, flightNumberStart }
}
